// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XngStickyWrapper } from "@steiner/App/Components/XngSticky/XngSticky";
import { myAccountDetailsPagesLayout } from "@steiner/App/Widgets/Layout/MyAccountDetailsPagesLayout";
import { DivWrapper } from "@steiner/XDL/constants";
import { color, hideElementOnPrint, showElementOnPrintOnly, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

myAccountDetailsPagesLayout.container = {
    css: css`
        display: flex;
        flex-direction: column;
        @media print {
            display: block;
        }
    `,
};

myAccountDetailsPagesLayout.informationContainer = {
    css: css`
        display: flex;
        gap: 22px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.information = {
    css: css`
        display: flex;
        flex-direction: column;
        @media print {
            display: block;
            h2 {
                font-size: 15px;
            }
        }
        ${xScreen("lte", "md")} {
            flex: 1 1 100%;
            width: 100%;
        }
        ${({ addSeparatorBorder }: any) =>
            addSeparatorBorder &&
            css`
                padding-bottom: 24px;
                border-bottom: 1px solid ${color("common.border")};
            `}
    `,
};
myAccountDetailsPagesLayout.productList = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.total = {
    css: css`
        flex: 0 0 319px;
        &,
        & ${XngStickyWrapper} {
            display: flex;
            flex-direction: column;
            gap: 16px;
            @media print {
                display: block;
            }

            & ${DivWrapper} {
                @media print {
                    break-inside: avoid;
                    page-break-inside: avoid;
                    -webkit-column-break-inside: avoid;
                    &:empty {
                        display: none;
                    }
                }
            }
        }
        @media print {
            display: block;
            max-width: 450px;
        }

        ${xScreen("lte", "md")} {
            flex-basis: 100%;
            max-width: none;
        }
        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }
    `,
};
myAccountDetailsPagesLayout.totalPrint = {
    css: css`
        ${showElementOnPrintOnly}
    `,
}
myAccountDetailsPagesLayout.totalWrapper = {
    css: css`
         ${({ moveTotalToTopOnPrint }: any) =>
            moveTotalToTopOnPrint &&
            css`
                ${hideElementOnPrint}
            `}
    `,
}
myAccountDetailsPagesLayout.productLisContainer = {
    css: css`
        &:empty,
        &:has(> div:empty) {
            display: none;
        }
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.xngStickyStyles = {
    css: css`
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
myAccountDetailsPagesLayout.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    `,
};

myAccountDetailsPagesLayout.details = {
    css: css`
        display: flex;
        column-gap: 22px;
        ${xScreen("lt", "md")} {
            flex-direction: column;
        }
        @media print {
            display: block;
        }
        ${({ addSeparatorBorder }: any) =>
            addSeparatorBorder &&
            css`
                border-bottom: 1px solid ${color("common.border")};
                margin-bottom: 24px;
            `}
    `,
};

myAccountDetailsPagesLayout.detailsLeftColumn = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        ${xScreen("gte", "lg")} {
            & > div {
                margin-bottom: 20px;
                &:empty {
                    display: none;
                }
            }
        }

        ${({ moveTotalToTopOnPrint }: any) =>
        moveTotalToTopOnPrint &&
            css`
                @media print {
                    flex-direction: row;
                    justify-content: space-between;
                    gap: 22px;
                }
            `}
    `,
};

myAccountDetailsPagesLayout.detailsRightColumn = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        & > div {
            margin-bottom: 20px;
            &:empty {
                display: none;
            }
        }
    `,
};
